export interface IScenarioPopup {
  open: boolean;
  setOpen: (val: boolean) => void;
}

export const DEFAULT_MIN = 5;

export const estimateMins = (
  hours?: number,
  fallbackHour = DEFAULT_MIN,
): number => {
  if (typeof hours !== 'number' || !Number.isFinite(hours)) return fallbackHour;
  return Math.ceil(hours / 2);
};
